export const ru = {
    person_header: 'Пользователь',
    company_header: 'Компания',
    group_header: 'Тревел-политика / группа',
    suggest_placeholder: 'Начните вводить фамилию, имя или почту',
    no_group: 'Нет',
    not_found__description: 'Попробуйте поискать иначе или добавьте нового пользователя',
    not_found__title: 'Не удалось найти пользователя',
};
